/**
 * class: Config
 */
export class Config {
    private static _instance: Config = undefined;
    public static get me(): Config {
        if (Config._instance == undefined) Config._instance = new Config;
        return Config._instance;
    }

    public isTouchMode(el: any): boolean {
        return this.sysenv.isMobileOrTablet() && !this.sysenv.isWindowsTouch() && ("ontouchstart" in el);
    }
    private _sysEnv: SystemEnv;

    public get sysenv(): SystemEnv { return this._sysEnv; }

    constructor() {
        this._sysEnv = new SystemEnv;
    }
}

/**
 * class: SystemEnv
 */
export class SystemEnv {
    ua: { Tablet: boolean, Mobile: boolean, iOS: boolean, Android: boolean, WindowsTouch: boolean, WindowsPhone: boolean, Safari: boolean, IE: boolean, Edge: boolean };

    constructor() {

        (this.ua as any) = (function (u) {
            return {
                Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1)
                    || (u.indexOf('ipad') > 0 || (u.indexOf('macintosh') > -1 && 'ontouchend' in document))
                    || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
                    || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
                    || u.indexOf("kindle") != -1
                    || u.indexOf("silk") != -1
                    || u.indexOf("playbook") != -1,
                Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
                    || u.indexOf("iphone") != -1
                    || u.indexOf("ipod") != -1
                    || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
                    || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
                    || u.indexOf("blackberry") != -1,
                iOS: (u.indexOf('ipad') > 0 || (u.indexOf('macintosh') > -1 && 'ontouchend' in document))
                    || u.indexOf("iphone") != -1
                    || u.indexOf("ipod"),
                IE: (u.indexOf("msie") != -1 || u.indexOf("trident") != -1),
                Safari: (u.indexOf("chrome") == -1 && u.indexOf("safari") != -1),
                Edge: (u.indexOf("edge") != -1),
                Android: (u.indexOf("android") != -1 && u.indexOf("mobile") == -1),
                WindowsTouch: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1),
                WindowsPhone: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
            }
        })(window.navigator.userAgent.toLowerCase());

        console.log(this.ua);
    }

    public isPoorPlatform(): boolean {
        return this.ua.Mobile || this.ua.Tablet;
    }
    public isMobileOrTablet(): boolean {
        return this.ua.Mobile || this.ua.Tablet;
    }
    public isiOS(): boolean {
        return this.ua.iOS;
    }
    public isAndroid(): boolean {
        return this.ua.Android;
    }
    public isWindowsTouch(): boolean {
        return this.ua.WindowsTouch;
    }
    public isSafari(): boolean {
        return this.ua.Safari;
    }
    public isEdgeorNot(): boolean {
        return this.ua.Edge;
    }
    public isIEorNot(): boolean {
        return this.ua.IE;
    }

    public static islocalhost: boolean = ((typeof document != 'undefined') && (document.location.hostname == "localhost" || document.location.hostname == "127.0.0.1"));
    public static getQueries(): {} {
        if ((typeof document != 'undefined') && (1 < document.location.search.length)) {
            let query = document.location.search.substring(1);
            let parameters = query.split('&');
            let result: any = {};
            for (var i = 0; i < parameters.length; i++) {
                let element = parameters[i].split('=');
                let paramName = decodeURI(element[0]);
                let paramValue = decodeURI(element[1]);
                result[paramName] = paramValue;
            }
            return result;
        }
        return undefined;
    }
}
